module.exports = __webpack_public_path__ + "static/img/COC2023-3.a5d5bb8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-3.png
// module id = 9At1
// module chunks = 0